import { render } from "./Card.vue?vue&type=template&id=c71d6d8e&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=c71d6d8e&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71d6d8e"]])

export default __exports__